// code generated by pbf v4.0.1

export function readTsFeed(pbf, end) {
    return pbf.readFields(readTsFeedField, {name: "", stations: []}, end);
}
function readTsFeedField(tag, obj, pbf) {
    if (tag === 1) obj.name = pbf.readString();
    else if (tag === 2) pbf.readPackedVarint(obj.stations);
}
export function writeTsFeed(obj, pbf) {
    if (obj.name) pbf.writeStringField(1, obj.name);
    if (obj.stations) pbf.writePackedVarint(2, obj.stations);
}

export function readTsMap(pbf, end) {
    return pbf.readFields(readTsMapField, {feeds: [], Times: [], Concentrations: []}, end);
}
function readTsMapField(tag, obj, pbf) {
    if (tag === 1) obj.feeds.push(readTsFeed(pbf, pbf.readVarint() + pbf.pos));
    else if (tag === 2) pbf.readPackedVarint(obj.Times);
    else if (tag === 3) pbf.readPackedVarint(obj.Concentrations, true);
}
export function writeTsMap(obj, pbf) {
    if (obj.feeds) for (const item of obj.feeds) pbf.writeMessage(1, writeTsFeed, item);
    if (obj.Times) pbf.writePackedVarint(2, obj.Times);
    if (obj.Concentrations) pbf.writePackedVarint(3, obj.Concentrations);
}
